(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('.pmti-reviews__write');
    const closeButton = event.target.closest('.pmti-review-dialog__close');

    if (openButton) {
      const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (!dialog) return;

      dialog.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      dialog.querySelector('input[type="radio"]')?.focus();
      return;
    }

    const dialog = event.target.closest('.pmti-review-dialog');
    if (closeButton || event.target === dialog) {
      const activeDialog = closeButton?.closest('.pmti-review-dialog') || dialog;
      if (!activeDialog) return;

      activeDialog.hidden = true;
      document.body.style.overflow = '';
      const trigger = document.querySelector(`[aria-controls="${activeDialog.id}"]`);
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const dialog = document.querySelector('.pmti-review-dialog:not([hidden])');
    if (!dialog) return;

    dialog.hidden = true;
    document.body.style.overflow = '';
    const trigger = document.querySelector(`[aria-controls="${dialog.id}"]`);
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.pmti-review-form');
    if (!form) return;

    const firstName = form.querySelector('[id^="pmti-review-first-name-"]');
    const lastInitial = form.querySelector('[id^="pmti-review-last-initial-"]');
    const reviewText = form.querySelector('[id^="pmti-review-text-"]');
    const rating = form.querySelector('input[name="pmti_review_rating"]:checked');
    const authorField = form.querySelector('.pmti-review-form__author');
    const bodyField = form.querySelector('.pmti-review-form__body');

    if (!firstName || !lastInitial || !reviewText || !rating || !authorField || !bodyField) return;

    const initial = lastInitial.value.trim().charAt(0).toUpperCase();
    authorField.value = `${firstName.value.trim()} ${initial}.`;
    bodyField.value = `${rating.value}|${reviewText.value.trim()}`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('pmti-resource-browser')) {
    customElements.define('pmti-resource-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.searchInput = this.querySelector('[data-pmti-search]');
        this.formatSelect = this.querySelector('[data-pmti-format]');
        this.topicSelect = this.querySelector('[data-pmti-topic]');
        this.grid = this.querySelector('[data-pmti-grid]');
        this.count = this.querySelector('[data-pmti-count]');
        this.empty = this.querySelector('[data-pmti-empty]');
        this.reset = this.querySelector('[data-pmti-reset]');
        this.countTemplateOne = this.count.dataset.countOne;
        this.countTemplateOther = this.count.dataset.countOther;
        this.setInitialFilters();
        this.searchInput.addEventListener('input', () => this.applyFilters());
        this.formatSelect.addEventListener('change', () => this.applyFilters(true));
        this.topicSelect.addEventListener('change', () => this.applyFilters(true));
        this.reset.addEventListener('click', () => this.clearFilters());
        this.prepareLibrary();
      }

      setInitialFilters() {
        const params = new URLSearchParams(window.location.search);
        this.searchInput.value = params.get('q') || '';
        this.formatSelect.value = params.get('format') || '';
        this.topicSelect.value = params.get('topic') || '';
        const currentTag = this.dataset.currentTag;
        if (!currentTag || this.formatSelect.value || this.topicSelect.value) return;
        if (currentTag.startsWith('topic-')) {
          this.topicSelect.value = currentTag;
        } else if (currentTag === 'free-course') {
          this.formatSelect.value = 'free';
        } else {
          this.formatSelect.value = currentTag;
        }
      }

      async prepareLibrary() {
        this.setAttribute('aria-busy', 'true');
        try {
          if (this.dataset.currentTag) {
            const library = await this.fetchBrowser(this.dataset.libraryUrl);
            if (library) {
              this.grid.replaceChildren(...this.cloneCards(library));
              await this.loadFollowingPages(library.dataset.nextUrl);
            }
          } else {
            await this.loadFollowingPages(this.dataset.nextUrl);
          }
        } catch (error) {
          this.dataset.loadError = 'true';
        }
        this.removeAttribute('aria-busy');
        this.applyFilters();
      }

      async loadFollowingPages(nextUrl) {
        let url = nextUrl;
        while (url) {
          const browser = await this.fetchBrowser(url);
          if (!browser) break;
          this.grid.append(...this.cloneCards(browser));
          url = browser.dataset.nextUrl;
        }
      }

      async fetchBrowser(url) {
        if (!url) return null;
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return null;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        return documentFragment.querySelector('pmti-resource-browser');
      }

      cloneCards(browser) {
        return Array.from(browser.querySelectorAll('[data-pmti-card]')).map((card) => card.cloneNode(true));
      }

      applyFilters(updateUrl = false) {
        const query = this.searchInput.value.trim().toLowerCase();
        const format = this.formatSelect.value;
        const topic = this.topicSelect.value;
        let visible = 0;
        this.querySelectorAll('[data-pmti-card]').forEach((card) => {
          const tags = card.dataset.tags || '';
          const search = card.dataset.search || '';
          const matchesSearch = !query || search.includes(query);
          let matchesFormat = !format || tags.includes(`|${format}|`);
          if (format === 'course') matchesFormat = tags.includes('|course|') || tags.includes('|free-course|');
          if (format === 'free') matchesFormat = tags.includes('|free|') || tags.includes('|free-course|');
          const matchesTopic = !topic || tags.includes(`|${topic}|`);
          const matches = matchesSearch && matchesFormat && matchesTopic;
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        const countTemplate = visible === 1 ? this.countTemplateOne : this.countTemplateOther;
        this.count.textContent = countTemplate.replace('__COUNT__', visible.toLocaleString());
        this.empty.hidden = visible !== 0;
        if (updateUrl) this.updateUrl();
      }

      updateUrl() {
        const url = new URL(this.dataset.libraryUrl, window.location.origin);
        if (this.searchInput.value.trim()) url.searchParams.set('q', this.searchInput.value.trim());
        if (this.formatSelect.value) url.searchParams.set('format', this.formatSelect.value);
        if (this.topicSelect.value) url.searchParams.set('topic', this.topicSelect.value);
        window.history.replaceState({}, '', url);
      }

      clearFilters() {
        this.searchInput.value = '';
        this.formatSelect.value = '';
        this.topicSelect.value = '';
        this.applyFilters(true);
        this.searchInput.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmti-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-pmti-draft]');
    const countdown = root?.querySelector('[data-pmti-countdown]');
    if (!countdown) return;
    const target = new Date(countdown.dataset.pmtiCountdown).getTime();
    const update = () => {
      const remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      countdown.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      countdown.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      countdown.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      countdown.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    };
    update();
    window.setInterval(update, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
